/**
 * Bounded vehicle reference lists (T12 interim, frontend-only). Defined ONCE here;
 * pages import instead of inlining arrays.
 */

/** Oldest selectable model year. CHANGE-TOGETHER with the backend catalog seeder
 * (src/apps/catalog/seeders/vehicles.py MIN_YEAR): both floor here. */
const MIN_YEAR = 1990;

/** Selectable model years, newest first (current year → MIN_YEAR). Derived from the
 * current year so the rolling upper bound never goes stale in January — the backend
 * seeder derives the same bound (MAX_YEAR = current year), keeping the pickable range
 * and seeded catalog coverage in lockstep without a hardcoded max in either place. */
const YEARS = Array.from(
  { length: new Date().getFullYear() - MIN_YEAR + 1 },
  (_, index) => String(new Date().getFullYear() - index),
);

export { MIN_YEAR, YEARS };
